import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-is-loading',
    templateUrl: './is-loading.component.html',
    styleUrls: ['./is-loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IsLoadingComponent{

  constructor() { }

}
